import { render, staticRenderFns } from "./courseClass0.vue?vue&type=template&id=e9c24db6&scoped=true&"
import script from "./courseClass0.vue?vue&type=script&lang=js&"
export * from "./courseClass0.vue?vue&type=script&lang=js&"
import style0 from "./courseClass0.vue?vue&type=style&index=0&id=e9c24db6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c24db6",
  null
  
)

export default component.exports